import React from "react";
import AsyncAutoCompleteContained from "../../AsyncAutoCompleteContained";
import { AutoCompleteProps } from "../../../Types/AutoComplete/AutoCompleteProps"


const AccountAutoComplete: React.FC<AutoCompleteProps> = ({ onChange, valueId, label = "Account", load = true, disabled = false, infoText, error, helperText }) => {
    return (
        <AsyncAutoCompleteContained
            label={label}
            url="/autocompleteApi/GetAccounts"
            valueId={valueId}
            load={load}
            onChange={onChange}
            disabled={disabled}
            infoText={infoText}
            error={error}
            helperText={helperText}
        />
    );
};

export default AccountAutoComplete;
